import React, {  } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import dayjs, {  } from 'dayjs';


import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useEffect } from 'react';
import DebugLog from '../../utils/DebugLog';

const ToAndFromDatePickerDialog = ({ open, onClose, onSelect , type}) => {

  const today = dayjs();
  const [selectedDate, setSelectedDate] = React.useState(today);

  let startDate = dayjs();
  let endDate = dayjs();

  useEffect(() => {

  }, []);
  

  const handleClose = () => {
    DebugLog("selectedDate  "+dayjs(selectedDate).format('YYYY/MM/DD'))
    onClose();
  };

  const setTodaysDate = () => {
    // Get today's date
    const today = dayjs();
    // Format today's date (optional)
    const formattedDate = today.format("YYYY/MM/DD");
    setSelectedDate(formattedDate);
  };


  const handleDateChange = (date) => {
    setSelectedDate(date);
   
  };

  const handleConfirm = () => {
    onSelect(dayjs(selectedDate).format('YYYY/MM/DD'),type);
    DebugLog("selectedDate  "+selectedDate)
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Select Date</DialogTitle>
      
      <DialogContent>
    
        <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={['DatePicker']}>
        <DatePicker
            //defaultValue={setTodaysDate}
            label="Choose Date"
            value={selectedDate}
            onChange={(newValue) => setSelectedDate(newValue)}
            //maxDate={today}
            minDate={today}
           
          />
           </DemoContainer>
        </LocalizationProvider>
      
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleConfirm} color="primary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ToAndFromDatePickerDialog;
